import nativeProxy from '@nativeApp/ssr/nativeProxy';
import Cookies from 'js-cookie';
import { isMobile } from '../device';
import { isInEnPC } from '../en';
import { getUrlParam } from '../urlParse';
import { jsonToString } from '../format';

// 获取上报的设备信息
export const getDeviceInfo = () => {
  if (nativeProxy.isInApp()) {
    return 'ENM';
  }

  if (isInEnPC()) {
    return 'ENPC';
  }

  return isMobile() ? '移动端new' : 'PC端new';
};

// 获取默认上报的参数
export const getDefaultParam = () => {
  const getChannel = () => {
    let channel = Cookies.get('channel') || Cookies.get('entry') || getUrlParam('channel') || '';
    if (channel && !/^\w+$/.test(channel)) {
      channel = 'format_error';
    }
    return channel;
  };

  return {
    device: getDeviceInfo(),
    $tid: Cookies.get('userId') || Cookies.get('fingerprint') || 'nobody',
    $is_user: Cookies.get('userId') ? 1 : '',
    username: Cookies.get('userId') || 'nobody',
    $longitude: Cookies.get('longitude') || '',
    $latitude: Cookies.get('latitude') || '',
    stageId: Cookies.get('stageId') || '',
    stageName: Cookies.get('stageName') || '',
    subjectId: Cookies.get('subjectId') || '',
    subjectName: Cookies.get('subjectName') || '',
    referer: document.referrer || '',
    isLogin: Cookies.get('isLogin'),
    channel: getChannel(),
  };
};

// 获取链接的参数用于上报
export const getLinkParam = (obj) => {
  const params = { ...getDefaultParam(), ...obj };

  if (/zone/i.test(location.pathname)) {
    params.channel = 'zhuanqu';
    params.zonename =
      window.__INITIAL_STATE__.title || window.__INITIAL_STATE__.detail.data.name || '';
    Cookies.set('channel', 'zhuanqu', { path: '/zone' });
  }

  return jsonToString(params);
};
